__turbopack_context__.v({
  "capsule": "RangeColumns-module__fKk5PG__capsule",
  "guide": "RangeColumns-module__fKk5PG__guide",
  "svg": "RangeColumns-module__fKk5PG__svg",
  "wrap": "RangeColumns-module__fKk5PG__wrap",
});
